import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExcelService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public extractExcel(excel: any): Observable<any> {
    return this.http.post(this.endpoint('api', 'excelservice', 'json'), excel);
  }

  public generateExcel(excel: Excel): Observable<any> {
    return this.http.post(this.endpoint('api', 'excelservice', 'xlsx'), excel, { responseType: 'blob' });
  }

  public generateDsoExcel(excel: Excel): Observable<any> {
    return this.http.post(this.endpoint('api', 'dsos', 'substations', 'excel'), excel, { responseType: 'blob' });
  }

  public generateCustomExcel(excel: Excel): Observable<any> {
    return this.http.post(this.endpoint('api', 'excelservice', 'custom-xlsx'), excel, { responseType: 'blob' });
  }

  public generateExterneAppExcel(excel: Excel[]): Observable<any> {
    const excelData = { ExcelFile: excel };
    return this.http.post(this.endpoint('api', 'excelworksheetservice', 'xlsx'), excelData, { responseType: 'blob' });
  }
}

export interface Excel {
  fileName: string;
  sheetName: string;
  headers: string[];
  data: string[][];
  customHeader?: (string | number)[][];
  protectedColumns: number[];
  templateCode: string;
  headerBgColor: string;
  secretPhrase: string;
  customHeaderBgColor?: string;
  isFifteenMinute?: boolean | false;
}
